import { getAllAximaProducts, AddAximaDomain } from "../../http/aximaHttp/AximaDomainHttp";
import { axima_billing_frequency } from "../../util/enum";
import { createPortal } from "react-dom"
import Div from "../Div";
import Input from "../Input";
import FormButton from "../FormButton";
import { useEffect, useState } from "react";
import Select from "../Select";
import Form from "../Form";

function AddAximaDomainModal({ handleClicked, ...props }) {

    const [inputDomain, setInputDomain] = useState({
        ticket_number: '',
        customer_name: '',
        customer_email : '',
        companyName: '',
        domain_name: '',
        tenant_name: '',
        user_count: '',
        product: '',
        comments: '',
        order_id: '',
        start_date: '',
        renewal_date: '',
        requested_by: '',
        field_distributor: '',
        billing_frequency: ''

    })

    const [product, setProduct] = useState()

    const [error, setError] = useState(false)

    const getAximaProducts = async () => {
        const response = await getAllAximaProducts()
        const products = response?.products.map((product) =>
            <option key={product.ap_id}
                name={product.ap_id}
                value={product.ap_id}>
                {product.axima_product_name}</option>)

        setProduct(products)
    }

    const comments_status = axima_billing_frequency.billing_frequency.map((frequency) =>
        frequency.id !== axima_billing_frequency ?
            <option key={frequency.id}
                name={frequency.id}
                value={frequency.value}>
                {frequency.value}</option>
            : null);

    useEffect(() => {
        getAximaProducts()
    }, [])

    function handleClose() {
        handleClicked(false);
    }

    async function handleAddDomain(event) {

        event.preventDefault();
        const statusFD = new FormData(event.target)

        const data = Object.fromEntries(statusFD.entries())

        const domain = await AddAximaDomain(data)

        if (domain) {
            window.location.href = '/home/add_axima_domain'
        }
        else {
            setError("Failed to Add Axima Domain")
        }
    }

    return (
        <>
            {createPortal(
                <Div className="modal-backdrop">
                    <dialog {...props}
                    // style={{ zIndex: '1', maxWidth: '85%' }}
                    >

                        <Div className="form-group">
                            Add Axima Domain
                        </Div>
                        <Div className='scroll-container'
                            style={{
                                overflowY: "auto",
                                height: "604px",
                                width: "100%",
                                border: "1px solid #000",
                                padding: "10px",
                            }}>
                            <Form onSubmit={handleAddDomain}>



                                <Div className="form-group">
                                    <label style={{ fontSize: 'smaller' }}>Ticket Number</label>
                                    <Input text='' onChange={(e) => setInputDomain((prev) => ({ ...prev, ticket_number: e.target.value }))} name="ticket_number"
                                        type="text" className="form-control" placeholder="Enter Ticket No." value={inputDomain.ticket_number} />
                                </Div>

                                <Div className="form-group">
                                    <label style={{ fontSize: 'smaller' }}>Customer Name</label>
                                    <Input text='' onChange={(e) => setInputDomain((prev) => ({ ...prev, customer_name: e.target.value }))} name="customer_name"
                                        type="text" className="form-control" placeholder="Enter Customer Name" />
                                </Div>

                                <Div className="form-group">
                                    <label style={{ fontSize: 'smaller' }}>Customer Email</label>
                                    <Input text='' onChange={(e) => setInputDomain((prev) => ({ ...prev, customer_email: e.target.value }))} name="customer_email"
                                        type="email" className="form-control" placeholder="Enter Customer Name" />
                                </Div>

                                <Div className="form-group">
                                    <label style={{ fontSize: 'smaller' }}>Customer Phone Number</label>
                                    <Input text='' onChange={(e) => setInputDomain((prev) => ({ ...prev, customer_email: e.target.value }))} name="phone_number"
                                        type="text" className="form-control" placeholder="Enter Phone Number" />
                                </Div>

                                <Div className="form-group">
                                    <label style={{ fontSize: 'smaller' }}>Company Name</label>
                                    <Input text='' onChange={(e) => setInputDomain((prev) => ({ ...prev, companyName: e.target.value }))} name="company_name"
                                        type="text" className="form-control" placeholder="Enter Company Name" />
                                </Div>
                                <Div className="form-group">
                                    <label style={{ fontSize: 'smaller' }}>Domain Name</label>
                                    <Input text='' onChange={(e) => setInputDomain((prev) => ({ ...prev, domain_name: e.target.value }))} name="domain_name"
                                        type="text" className="form-control" placeholder="Enter Domain Name" />
                                </Div>
                                <Div className="form-group">
                                    <label style={{ fontSize: 'smaller' }}>Tenant name</label>
                                    <Input text='' onChange={(e) => setInputDomain((prev) => ({ ...prev, tenant_name: e.target.value }))} name='tenant_name'
                                        type="text" className="form-control" placeholder="Enter Tenant Name" />
                                </Div>
                                <Div className="form-group">
                                    <label style={{ fontSize: 'smaller' }}>User Count</label>
                                    <Input text='' onChange={(e) => setInputDomain((prev) => ({ ...prev, user_count: e.target.value }))} name='user_count'
                                        type="text" className="form-control" placeholder="Enter User Count" />
                                </Div>
                                <Div className="form-group">
                                    <label style={{ fontSize: 'smaller' }}>Products</label>
                                    <Select text='' options={product} defaultValue='Select Product'
                                        className="form-control" name='product' />
                                </Div>
                                <Div className="form-group">
                                    <label style={{ fontSize: 'smaller' }}>Comments</label>
                                    <Input text='' onChange={(e) => setInputDomain((prev) => ({ ...prev, comments: e.target.value }))} name='comments'
                                        type="text" className="form-control" placeholder="Enter Comments" />
                                </Div>
                                <Div className="form-group">
                                    <label style={{ fontSize: 'smaller' }}>Order Id</label>
                                    <Input text='' onChange={(e) => setInputDomain((prev) => ({ ...prev, order_id: e.target.value }))} name='order_id'
                                        type="text" className="form-control" placeholder="Enter Order Id" />
                                </Div>
                                <Div className="form-group">
                                    <label style={{ fontSize: 'smaller' }}>Billing Frequency</label>
                                    <Select text='' options={comments_status} defaultValue='Select Frequency'
                                        className="form-control" name='billing_frequency' 
                                     />
                                </Div>
                                {/* <Div className="form-group">
                                    <label style={{ fontSize: 'smaller' }}>Start Date</label>
                                    <Input text='' onChange={(e) => setInputDomain((prev) => ({ ...prev, start_date: e.target.value }))} name='start_date'
                                        type="date" className="form-control" placeholder="Enter Start Date" />
                                </Div>*/
                               /* <Div className="form-group">
                                    <label style={{ fontSize: 'smaller' }}>Renewal Date</label>
                                    <Input text='' onChange={(e) => setInputDomain((prev) => ({ ...prev, renewal_date: e.target.value }))} name='renewal_date'
                                        type="date" className="form-control" placeholder="Enter End Date/ Renewal Date" disabled />
                                </Div> */}
                                <Div className="form-group">
                                    <label style={{ fontSize: 'smaller' }}>Selling Price</label>
                                    <Input text='' onChange={(e) => setInputDomain((prev) => ({ ...prev, start_date: e.target.value }))} name='selling_price'
                                        type="text" className="form-control" placeholder="Enter Selling Price" />
                                </Div>
                                <Div className="form-group">
                                    <label style={{ fontSize: 'smaller' }}>Buying Price</label>
                                    <Input text='' onChange={(e) => setInputDomain((prev) => ({ ...prev, start_date: e.target.value }))} name='buying_price'
                                        type="text" className="form-control" placeholder="Enter Buying Price" />
                                </Div>
                                <Div className="form-group">
                                    <label style={{ fontSize: 'smaller' }}>Margin Percent</label>
                                    <Input text='' onChange={(e) => setInputDomain((prev) => ({ ...prev, start_date: e.target.value }))} name='margin_percent'
                                        type="number" className="form-control" placeholder="Enter Margin" />
                                </Div>
                                <Div className="form-group">
                                    <label style={{ fontSize: 'smaller' }}>Request By</label>
                                    <Input text='' onChange={(e) => setInputDomain((prev) => ({ ...prev, requested_by: e.target.value }))} name='requested_by'
                                        type="text" className="form-control" placeholder="Enter Requested By" />
                                </Div>
                                <Div className="form-group">
                                    <label style={{ fontSize: 'smaller' }}>Field Distributor</label>
                                    <Input text='' onChange={(e) => setInputDomain((prev) => ({ ...prev, field_distributor: e.target.value }))} name='field_distributor'
                                        type="text" className="form-control" placeholder="Enter New Field Distributor" />
                                </Div>
                            
                                <Div className="form-group">
                                    <Div className='row'>
                                        <Div className='col-sm-6'>
                                            <FormButton type='submit' style={{ margin: '2px' }}
                                             className="btn btn-primary submit-btn btn-block">Add Domain</FormButton>
                                        </Div>
                                        <Div className='col-sm-6'>
                                            <FormButton type='button' onClick={handleClose} style={{ margin: '2px' }} className="btn btn-primary submit-btn btn-block" >Close</FormButton>
                                        </Div>
                                    </Div>

                                    <Div className='row'>
                                        <Div className='col-sm-12'>
                                            {error ? <p style={{ color: 'red', marginLeft: '15px', marginTop: '4px' }}> {error}</p> : null}
                                        </Div>
                                    </Div>
                                </Div>
                            </Form>
                        </Div>

                    </dialog>

                </Div>
                , document.getElementById('modal'))

            }
        </>
    )
}

export default AddAximaDomainModal;